import api from "./apis";
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";


export const getReports = (p, client, status, report, invalid_code ,ds, de) => async (dispatch) => {
   
  dispatch({ type: LOADING });
  try{
    let response = null;
    if(ds && de){
        response = await api(localStorage.getItem("token")).get(`/report-management/report?p=${p?p:1}&client=${client?client:""}&status=${status?status:""}&report=${report? report : ''}&invalid_code=${invalid_code?invalid_code: ''}&ds=${ds}&de=${de}&`);
    }
    else{
      response = await api(localStorage.getItem("token")).get(`/report-management/report?p=${p?p:1}&client=${client?client:""}&status=${status?status:""}&report=${report ? report : ''}&invalid_code=${invalid_code?invalid_code: ''}`);
    }
    
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}



export const getReportDetails = (batch) => async (dispatch) => {
    dispatch({ type: LOADING });
    try {
      const response = await api(localStorage.getItem("token")).get(
        `/report-management/report/detail?report=${batch}`
      );
      if (response.status === 200) {
        dispatch({ type: LOADED });
        return response.data.report;
      }
    } catch (err) {
      /* =============Start========== */
      if (err?.response?.status === 422) {
        err.response.data.errors.map((item) => {
          dispatch({
            type: VALIDATION_ERROR,
            payload: [{ message: item.message, path: item.path[0] }],
          });
        });
      }
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
        localStorage.clear();
        history.push("/login");
      }
      dispatch({
        type: ERROR_MESSAGE,
        payload: err.response ? err.response.data.message : history.push("/opps"),
      });
      dispatch({ type: LOADED });
      /* ===========End============*/
    }
  };

  
export const updateReportDone = (data,remark) => async (dispatch) => {
  dispatch({ type: LOADING });

  try {


    const obj = {
      report: data,
      remark: remark.remark,
    }
    const response = await api(localStorage.getItem("token")).patch("/report-management/report/done", {...obj});

    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Operation successful",
      });
      
      dispatch({ type: LOADED });
      return response.status
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};